import axios from 'axios';

/**
 * Handles GET request
 * @param url
 * @param params {Object}
 * @returns {Promise<any>}
 */
export const fetchCall = async (url: string, params?: unknown): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params })
      .then((response) => {
        if (response.status !== 200) reject(response);
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
};

/**
 * Handles POST request
 * @param url
 * @param requestBody {Object}
 * @returns {Promise<any>}
 */
export const postCall = async (url: string, requestBody?: unknown): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, requestBody)
      .then((response) => {
        if (response.status !== 200 && response.status !== 201) reject(response);
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};

/**
 * Handles PUT request
 * @param url
 * @param requestBody {Object}
 * @returns {Promise<any>}
 */
export const putCall = async (url: string, requestBody?: unknown): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, requestBody)
      .then((response) => {
        if (response.status !== 200 && response.status !== 201) reject(response);
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};

/**
 * Handles DELETE request
 * @param url
 * @param requestBody {Object}
 * @returns {Promise<any>}
 */
export const deleteCall = async (url: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url)
      .then((response) => {
        if (response.status !== 200 && response.status !== 201) reject(response);
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};
